<section class="container">
  <div class="xs-row">
    <div class="xs-12--none">
      <div class="container padding--none">
        <app-product-cards
          [replacementOffers]="replacementOffers"
          [rrpFlag]="rrpFlag"
          [comparisonsSelected]="comparisonsSelected"
          (cardClicked)="onCardClick($event)"
          (comparisonClicked)="onComparisonClick($event)"
          [visible]="visible"
        >
        </app-product-cards>
      </div>
    </div>
    <div class="xs-12 flex justify--center">
      <dgx-components-button
        class="showMore"
        *ngIf="visible < replacementOffers?.length"
        variant="secondary"
        (click)="onShowMoreClick()"
        >See more products</dgx-components-button
      >
    </div>
  </div>
</section>
